import { PaymentGateway } from '../../../../../services/exports/Constants';

export default {
  title: 'Apăsați butonul de mai jos pentru a revizui și confirma informațiile de plată.',
  payment_gateways: {
    [PaymentGateway.Stripe]: {
      description:
        'Colaborăm cu Stripe pentru procesarea plăților. Stripe este cea mai sigură platformă de plăți, folosită de cele mai mari companii din lume.',
      form: {
        terms_acceptance: {
          label:
            'Prin continuare, acceptați <FoodAmigosTerms>Acordul nostru de servicii</FoodAmigosTerms> și <StripeTerms>Acordul de cont conectat Stripe.</StripeTerms>',
        },
      },
      labels: {
        stripe_requirements: 'Stripe are încă nevoie de datele de mai jos sau nu le-a putut verifica:',
        errors: 'Erori',
        awaiting_verification: 'Contul dvs. Stripe este în curs de verificare',
        awaiting_verification_description:
          'Așteptăm ca Stripe să finalizeze verificarea afacerii dvs. Între timp, puteți revizui profilul.',
        details_hint:
          'Stripe verifică numele, adresele și numerele de telefon în registre oficiale. Dacă unul este greșit, corectați-l în Informațiile mele → Informații personale, iar Stripe îl va verifica din nou. Orice altceva solicită Stripe puteți adăuga în profilul dvs. Stripe.',
        requirements_hint:
          'Unele dintre acestea sunt documente, cum ar fi actul de identitate: încarcă-le la pasul anterior, {{step}}, apoi revino aici.',
        requirements_hint_profile:
          'Unele dintre acestea sunt documente, cum ar fi actul de identitate: încarcă-le în profilul tău Stripe.',
      },
      requirements: {
        of_subject: '{{subject}}: {{detail}}',
        subjects: {
          owner: 'Proprietar',
          representative: 'Reprezentant',
          business: 'Afacere',
        },
        details: {
          first_name: 'Prenume',
          last_name: 'Nume de familie',
          email: 'Email',
          phone: 'Număr de telefon',
          dob: 'Data nașterii',
          id_number: 'Număr de identificare',
          nationality: 'Naționalitate',
          address: 'Stradă și număr',
          city: 'Oraș',
          postal_code: 'Cod poștal',
          state: 'Județ',
          country: 'Țară',
          id_document: 'Document de identitate',
          proof_of_address: 'Dovadă de adresă',
          job_title: 'Funcție',
          business_name: 'Denumirea legală a afacerii',
          tax_id: 'Cod fiscal',
          vat_id: 'Cod de TVA',
          registration_number: 'Număr de înregistrare',
          website: 'Website',
          industry: 'Industrie',
          product_description: 'Descrierea a ceea ce vinzi',
          support_phone: 'Număr de telefon pentru suport clienți',
          owners: 'Confirmarea proprietarilor',
          directors: 'Confirmarea directorilor',
          executives: 'Confirmarea directorilor executivi',
          registration_document: 'Document de înregistrare a afacerii',
          bank_account: 'Cont bancar pentru plăți',
          business_type: 'Tip de afacere',
          terms: 'Acceptarea termenilor Stripe',
          bank_account_proof: 'Dovada deținerii contului bancar',
          tax_id_document: 'Document cod fiscal',
        },
      },
    },
    [PaymentGateway.Adyen]: {
      description:
        'Colaborăm cu Adyen pentru procesarea plăților. Adyen este una dintre cele mai sigure platforme de plată, utilizată de cele mai mari companii din lume.',
    },
  },
  labels: {
    verified: 'Contul dvs. {{paymentGateway}} este verificat',
    verified_description:
      'Verificarea pentru {{paymentGateway}} este finalizată. Puteți gestiona în continuare profilul dacă este necesar.',
  },
  buttons: {
    proceed: 'Confirmați informațiile de plată',
    copy_link: 'Copiați linkul',
    back: 'Înapoi',
  },
  toasts: {
    something_went_wrong: 'Ceva a mers greșit, vă rugăm să contactați suportul tehnic',
  },
};
